import React, { Children } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Link } from 'react-router-dom';
export function PrivacyPolicyPage() {
  return <div className="min-h-screen w-full bg-white selection:bg-slate-600 selection:text-white pt-20" data-id="element-299">
      <Header data-id="element-300" />

      <section className="py-24 px-6 lg:px-8 bg-gray-50" data-id="element-301">
        <div className="max-w-4xl mx-auto" data-id="element-302">
          <div className="mb-6 inline-block bg-slate-600 px-4 py-1 transform -skew-x-12" data-id="element-303">
            <span className="block transform skew-x-12 font-bold tracking-wider uppercase text-sm text-white" data-id="element-304">
              Legal
            </span>
          </div>
          <h1 className="text-4xl md:text-6xl font-black tracking-tighter text-black mb-4" data-id="element-305">
            PRIVACY <span className="text-slate-600" data-id="element-306">POLICY</span>
          </h1>
          <p className="text-gray-600 font-medium" data-id="element-307">
            Last updated: January 2025
          </p>
          <p className="text-gray-700 mt-4 font-bold" data-id="element-308">Raven Advisors LLC</p>
        </div>
      </section>

      <section className="py-16 px-6 lg:px-8 bg-white" data-id="element-309">
        <div className="max-w-4xl mx-auto prose prose-lg prose-gray" data-id="element-310">
          <div className="space-y-12" data-id="element-311">
            <div data-id="element-312">
              <h2 className="text-2xl font-black text-black uppercase tracking-tight mb-4" data-id="element-313">
                1. Information We Collect
              </h2>
              <div className="w-12 h-1 bg-slate-600 mb-6" data-id="element-314"></div>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-315">
                At Raven Advisors LLC, we collect information you provide
                directly to us when you:
              </p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2" data-id="element-316">
                <li data-id="element-317">
                  Contact us via phone, email, or through our website contact
                  forms
                </li>
                <li data-id="element-318">Request a cash offer for your property</li>
                <li data-id="element-319">Enter into a purchase agreement with us</li>
                <li data-id="element-320">Subscribe to our communications</li>
                <li data-id="element-321">Opt-in to receive SMS/text messages</li>
              </ul>
              <p className="text-gray-700 leading-relaxed mt-4" data-id="element-322">
                <strong data-id="element-323">Personal Information Collected:</strong> This
                information may include your name, phone number (including
                mobile number), email address, property address, and details
                about your property condition and situation.
              </p>
              <p className="text-gray-700 leading-relaxed mt-4" data-id="element-324">
                <strong data-id="element-325">Automatically Collected Information:</strong> We may
                automatically collect certain information when you visit our
                website, including your IP address, browser type, operating
                system, referring URLs, and information about how you interact
                with our website.
              </p>
            </div>

            <div data-id="element-326">
              <h2 className="text-2xl font-black text-black uppercase tracking-tight mb-4" data-id="element-327">
                2. How We Use Your Information
              </h2>
              <div className="w-12 h-1 bg-slate-600 mb-6" data-id="element-328"></div>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-329">
                We use the information we collect to:
              </p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2" data-id="element-330">
                <li data-id="element-331">
                  Provide, maintain, and improve our real estate purchasing
                  services
                </li>
                <li data-id="element-332">
                  Process transactions and send related information including
                  purchase confirmations
                </li>
                <li data-id="element-333">Respond to your comments, questions, and requests</li>
                <li data-id="element-334">
                  Communicate with you about our services, offers, and
                  promotions (with your consent)
                </li>
                <li data-id="element-335">
                  Send SMS/text messages if you have opted in to receive them
                </li>
                <li data-id="element-336">Comply with legal obligations</li>
                <li data-id="element-337">
                  Analyze usage patterns to improve our website and services
                </li>
              </ul>
            </div>

            <div data-id="element-338">
              <h2 className="text-2xl font-black text-black uppercase tracking-tight mb-4" data-id="element-339">
                3. SMS/Text Message Opt-In
              </h2>
              <div className="w-12 h-1 bg-slate-600 mb-6" data-id="element-340"></div>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-341">
                If you opt-in to receive SMS/text messages from Raven Advisors
                LLC:
              </p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2" data-id="element-342">
                <li data-id="element-343">
                  <strong data-id="element-344">Message Types:</strong> You may receive transactional
                  messages related to your property inquiry, appointment
                  reminders, offer updates, and closing information.
                </li>
                <li data-id="element-345">
                  <strong data-id="element-346">Message Frequency:</strong> Message frequency varies
                  based on your inquiry status and interaction with our
                  services.
                </li>
                <li data-id="element-347">
                  <strong data-id="element-348">Opt-Out:</strong> You can opt out at any time by
                  replying STOP to any SMS message. You will receive a
                  confirmation message and no further messages will be sent.
                </li>
                <li data-id="element-349">
                  <strong data-id="element-350">Help:</strong> Reply HELP to any message for
                  assistance or contact us at 630-639-3533.
                </li>
                <li data-id="element-351">
                  <strong data-id="element-352">Costs:</strong> Standard message and data rates may
                  apply. Check with your mobile carrier for details.
                </li>
              </ul>
              <p className="text-gray-700 leading-relaxed mt-4" data-id="element-353">
                <strong data-id="element-354">Mobile Information Sharing:</strong> We do not share
                your mobile phone number or SMS opt-in information with third
                parties for their marketing purposes. Your mobile information
                will only be used to send you messages related to your inquiry
                with Raven Advisors LLC and will not be shared with any
                third-party services except as necessary to deliver the messages
                (e.g., SMS gateway providers).
              </p>
            </div>

            <div data-id="element-355">
              <h2 className="text-2xl font-black text-black uppercase tracking-tight mb-4" data-id="element-356">
                4. Cookie & Tracking Practices
              </h2>
              <div className="w-12 h-1 bg-slate-600 mb-6" data-id="element-357"></div>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-358">
                Our website may use cookies and similar tracking technologies
                to:
              </p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2" data-id="element-359">
                <li data-id="element-360">Remember your preferences and settings</li>
                <li data-id="element-361">Understand how you use our website</li>
                <li data-id="element-362">Analyze website traffic and performance</li>
                <li data-id="element-363">Deliver relevant content and advertisements</li>
              </ul>
              <p className="text-gray-700 leading-relaxed mt-4" data-id="element-364">
                <strong data-id="element-365">Types of Cookies:</strong> We may use session cookies
                (which expire when you close your browser), persistent cookies
                (which remain until deleted), and third-party cookies from
                analytics providers.
              </p>
              <p className="text-gray-700 leading-relaxed mt-4" data-id="element-366">
                <strong data-id="element-367">Managing Cookies:</strong> You can set your browser to
                refuse cookies or alert you when cookies are being sent.
                However, some features of our website may not function properly
                without cookies.
              </p>
            </div>

            <div data-id="element-368">
              <h2 className="text-2xl font-black text-black uppercase tracking-tight mb-4" data-id="element-369">
                5. Information Sharing
              </h2>
              <div className="w-12 h-1 bg-slate-600 mb-6" data-id="element-370"></div>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-371">
                We do not sell, trade, or otherwise transfer your personal
                information to outside parties except in the following
                circumstances:
              </p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2" data-id="element-372">
                <li data-id="element-373">
                  With service providers who assist in our operations (title
                  companies, closing agents, SMS service providers)
                </li>
                <li data-id="element-374">
                  To comply with legal requirements or respond to lawful
                  requests
                </li>
                <li data-id="element-375">To protect our rights, privacy, safety, or property</li>
                <li data-id="element-376">
                  In connection with a merger, acquisition, or sale of assets
                </li>
              </ul>
              <p className="text-gray-700 leading-relaxed mt-4" data-id="element-377">
                <strong data-id="element-378">Mobile Information:</strong> Your mobile phone number
                and SMS consent information will never be shared with third
                parties for their marketing purposes.
              </p>
            </div>

            <div data-id="element-379">
              <h2 className="text-2xl font-black text-black uppercase tracking-tight mb-4" data-id="element-380">
                6. Data Security & Handling
              </h2>
              <div className="w-12 h-1 bg-slate-600 mb-6" data-id="element-381"></div>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-382">
                We implement appropriate technical and organizational measures
                to protect your personal information:
              </p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2" data-id="element-383">
                <li data-id="element-384">Secure data transmission using encryption (SSL/TLS)</li>
                <li data-id="element-385">
                  Limited access to personal information on a need-to-know basis
                </li>
                <li data-id="element-386">Regular security assessments and updates</li>
                <li data-id="element-387">Secure storage of physical and digital records</li>
              </ul>
              <p className="text-gray-700 leading-relaxed mt-4" data-id="element-388">
                However, no method of transmission over the Internet or
                electronic storage is 100% secure. While we strive to protect
                your information, we cannot guarantee absolute security.
              </p>
            </div>

            <div data-id="element-389">
              <h2 className="text-2xl font-black text-black uppercase tracking-tight mb-4" data-id="element-390">
                7. Your Rights
              </h2>
              <div className="w-12 h-1 bg-slate-600 mb-6" data-id="element-391"></div>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-392">
                You have the right to:
              </p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2" data-id="element-393">
                <li data-id="element-394">
                  <strong data-id="element-395">Access:</strong> Request access to the personal
                  information we hold about you
                </li>
                <li data-id="element-396">
                  <strong data-id="element-397">Correction:</strong> Request correction of inaccurate
                  or incomplete information
                </li>
                <li data-id="element-398">
                  <strong data-id="element-399">Deletion:</strong> Request deletion of your personal
                  information (subject to legal retention requirements)
                </li>
                <li data-id="element-400">
                  <strong data-id="element-401">Opt-Out of Marketing:</strong> Opt out of marketing
                  communications at any time
                </li>
                <li data-id="element-402">
                  <strong data-id="element-403">Opt-Out of SMS:</strong> Reply STOP to any text
                  message to stop receiving SMS communications
                </li>
                <li data-id="element-404">
                  <strong data-id="element-405">Data Portability:</strong> Request a copy of your data
                  in a portable format
                </li>
              </ul>
              <p className="text-gray-700 leading-relaxed mt-4" data-id="element-406">
                To exercise any of these rights, please contact us at
                ravenadvisorsllc@gmail.com or 630-639-3533.
              </p>
            </div>

            <div data-id="element-407">
              <h2 className="text-2xl font-black text-black uppercase tracking-tight mb-4" data-id="element-408">
                8. Data Retention
              </h2>
              <div className="w-12 h-1 bg-slate-600 mb-6" data-id="element-409"></div>
              <p className="text-gray-700 leading-relaxed" data-id="element-410">
                We retain your personal information for as long as necessary to
                fulfill the purposes for which it was collected, comply with
                legal obligations, resolve disputes, and enforce our agreements.
                Transaction records may be retained for up to 7 years for tax
                and legal compliance purposes.
              </p>
            </div>

            <div data-id="element-411">
              <h2 className="text-2xl font-black text-black uppercase tracking-tight mb-4" data-id="element-412">
                9. Children's Privacy
              </h2>
              <div className="w-12 h-1 bg-slate-600 mb-6" data-id="element-413"></div>
              <p className="text-gray-700 leading-relaxed" data-id="element-414">
                Our services are not directed to individuals under 18 years of
                age. We do not knowingly collect personal information from
                children. If you believe we have collected information from a
                minor, please contact us immediately.
              </p>
            </div>

            <div data-id="element-415">
              <h2 className="text-2xl font-black text-black uppercase tracking-tight mb-4" data-id="element-416">
                10. Changes to This Policy
              </h2>
              <div className="w-12 h-1 bg-slate-600 mb-6" data-id="element-417"></div>
              <p className="text-gray-700 leading-relaxed" data-id="element-418">
                We may update this Privacy Policy from time to time. Changes
                will be posted on this page with an updated revision date. We
                encourage you to review this policy periodically.
              </p>
            </div>

            <div data-id="element-419">
              <h2 className="text-2xl font-black text-black uppercase tracking-tight mb-4" data-id="element-420">
                11. Contact Us
              </h2>
              <div className="w-12 h-1 bg-slate-600 mb-6" data-id="element-421"></div>
              <p className="text-gray-700 leading-relaxed" data-id="element-422">
                If you have any questions about this Privacy Policy or our data
                practices, please contact us at:
              </p>
              <div className="mt-4 p-6 bg-gray-50 border-l-4 border-slate-600" data-id="element-423">
                <p className="font-bold text-black" data-id="element-424">Raven Advisors LLC</p>
                <p className="text-gray-700" data-id="element-425">
                  Email: ravenadvisorsllc@gmail.com
                </p>
                <p className="text-gray-700" data-id="element-426">Phone: 630-686-7233</p>
              </div>
              <p className="text-gray-700 leading-relaxed mt-4" data-id="element-427">
                See also our{' '}
                <Link to="/terms" className="text-slate-600 underline hover:text-black" data-id="element-428">
                  Terms of Service
                </Link>
                .
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer data-id="element-429" />
    </div>;
}